export default __webpack_public_path__ + "static/media/grid_background.4d84799b.jpg";